import React from 'react';
import { BpmTable } from './BpmTable';

export const DownloadsUSRegionsTable = ({ regionToDownloads }) => {
    if (!regionToDownloads) {
        return null;
    }
    const rowsAndCols = getTableRowsAndCols(regionToDownloads);
    return (
        <BpmTable
            cols={rowsAndCols.cols}
            data={rowsAndCols.rows}
        />
    );
}

function getTableRowsAndCols(regionToDownloads) {
    const result = {
        rows: [], cols: [
            {
                title: 'Region', field: 'region'
            },
            {
                title: 'Family Downloads', field: 'downloads'
            }]
    };

    for (const [key, value] of regionToDownloads) {
        const row = {
            region: key,
            downloads: value
        }
        result.rows.push(row);
    }

    return result;
}